import {noop} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {PaletteColorsEnum} from '../../../../../libs/shared/core/src/models/api/paletteModel';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {InfoBubblePillVariantsEnum} from '../../../../../libs/shared/ui/src/components/tip/infoBubblePill';
import {EducationTip} from '../../../educationTips/educationTip';
import {ConversationHeaderPill} from '../../../inboxes/viewer/conversation/header/conversationHeaderPill';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

/*
 * Style.
 */

const StyledTagPill = styled.div`
  display: inline-flex;
  margin: 0 4px;
`;

const StyledUl = styled.ul`
  padding-left: 20px;
  margin: 5px 0;
`;

/*
 * Component.
 */

export const RulesAppliedEducationTip: FC<SandboxEducationTipProps> = (props) => (
  <EducationTip
    anchor={props.anchor}
    position="left"
    isVisible={props.isVisible}
    isStandalone
    onRequestClose={noop}
    pillType={InfoBubblePillVariantsEnum.EDUCATION}
    title={<Trans id="infobubble-onboarding-rules-applied-title">Rules applied to this conversation</Trans>}
    stepCounter={generateStepText(3, 4)}
    primaryActionLabel={<Trans id="infobubble-onboarding-rules-applied-primary-showcase-growth">Next</Trans>}
    onPrimaryClick={props.onNextClick}
    dataObjectName={OnboardingDataEventObject.DEMO_RULES_APPLIED}
  >
    <StyledUl>
      <li>
        <Trans id="infobubble-onboarding-rules-applied-item1">
          <strong>Tagged with</strong>
          <StyledTagPill>
            <ConversationHeaderPill color={PaletteColorsEnum.YELLOW}>VIP customers</ConversationHeaderPill>
          </StyledTagPill>
          based on your team&apos;s criteria for priority customers.
        </Trans>
      </li>
      <li>
        <Trans id="infobubble-onboarding-rules-applied-item2-showcase-growth">
          <strong>Assigned to a teammate</strong> to ensure no VIP conversation falls through the cracks.
        </Trans>
      </li>
    </StyledUl>
  </EducationTip>
);
